export default function reference(item) {
  const id = item.id || item.gid || item.funderId;
  return id?.replace(/\W/g, "");
}
